const getters = {
  servicesData: (state) => state.services
};

export default {
  getters
};
